export const getCdnImage = (imagePathEncoded: string): string =>
    `${process.env.Images_Base_URL}/${imagePathEncoded}`;

export const getAssetsImage = (imagePathEncoded: string): string =>
    `${process.env.Assets_Base_URL}/${imagePathEncoded}`;
